module.exports = __webpack_public_path__ + "static/73-119af342037c82c09c33e6d862ff8e2a.png";